// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1244":"57cfa7f6","1703":"57cfa7f6","3648":"48484966","9762":"57cfa7f6"}[chunkId] + ".chunk.css";
};